var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBookmarkPin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 30 30",
    style: {
      enableBackground: "new 0 0 30 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#686868;stroke:#686868;stroke-width:0.2;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7.8,7.7L7.3,7.2L6.8,6.7C6.8,6.6,6.7,6.5,6.6,6.4c0,0,0,0,0,0L6.4,6.3l1.8-1.8L8.2,4.4 c-0.7-0.7-1.8-1-2.7-0.7L4.9,3.1c0.1-0.6-0.1-1.2-0.6-1.6L4.2,1.4L1.4,4.2l0.1,0.1c0.4,0.4,1,0.6,1.6,0.6l0.6,0.6 c-0.3,1-0.1,2,0.7,2.7l0.1,0.1l1.8-1.8l0.2,0.2c0,0,0,0,0,0c0.1,0.1,0.2,0.2,0.2,0.2l0.6,0.6l0,0l0.4,0.4l0.2,0.2 C8,8.1,8.1,8.2,8.2,8.2c0-0.1-0.1-0.2-0.2-0.3L7.8,7.7z M3.9,5.4L3.9,5.4L3.2,4.6l-0.1,0c-0.5,0.1-1-0.1-1.4-0.4l2.5-2.5 c0.3,0.4,0.5,0.9,0.4,1.4l0,0.1L5.4,4l0.1,0c0.9-0.3,1.8-0.1,2.5,0.5L4.4,7.9C3.8,7.3,3.6,6.3,3.9,5.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarkPin);
export default __webpack_public_path__ + "static/media/bookmark-pin.52ebeb15eafd18b21d95d32dbcaefe74.svg";
export { ForwardRef as ReactComponent };